<template>
	<div v-if="showReceipt" class="vastrans-receipt" >
		<div class="vasreceipt-content-container" ref="printableContent">
			<div
				class="vasreceipt-content"
				id="receipt"
				style="margin: auto;width: 330px !important;background-color: #fff !important;font-size: 10px !important; padding: 5px;"
			>
				<div
					class="receipt-header"
					style="font-size: 15px !important;border-bottom: 2px solid black;padding: 12px; text-align: center;"
				>
						<img :src="logo" alt="logo" style="max-width: 80%; width: 50%;"/>
					<p>{{ receiptDetail.location }}</p>
				</div>
				<div class="receipt-body">
					<div class="details">
						<div class="col">
							<div
								class="item-row"
								style="display: flex; justify-content: space-between;"
							>
								<p>TERMINAL ID:</p>
								<p>{{ receiptDetail.terminalId }}</p>
							</div>
							<div
								class="item-row"
								style="display: flex; justify-content: space-between;"
							>
								<p>WID:</p>
								<p>{{ receiptDetail.walletId }}</p>
							</div>
							<div
								class="item-row"
								style="display: flex; justify-content: space-between;"
							>
								<p>PAYMENT METHOD:</p>
								<p>{{ receiptDetail.paymentMethod }}</p>
							</div>
							<div
								class="item-row"
								style="display: flex; justify-content: space-between;"
							>
								<p>DATE:</p>
								<p>{{ moment(receiptDetail.createdAt).format("DD-MM-Y") }}</p>
							</div>
							<div
								class="item-row"
								style="display: block; justify-content: space-between;"
							>
								<p>NAME:</p>
								<p style="word-wrap: break-word;">
									{{ receiptDetail.customerName }}
								</p>
							</div>
							<div
								class="item-row"
								style="display: flex; justify-content: space-between;"
							>
								<p>BANK:</p>
								<p>{{ receiptDetail.bankName }}</p>
							</div>
							<div
								class="item-row"
								style="display: flex; justify-content: space-between;"
							>
								<p>ACC NUMBER:</p>
								<p>{{ receiptDetail.account }}</p>
							</div>
							<div
								class="item-row"
								style="display: flex; justify-content: space-between;"
							>
								<p>TRANS TYPE:</p>
								<p>{{ receiptDetail.product }}</p>
							</div>
							<div
								class="item-row"
								style="display: block"
							>
								<p>REF:</p>
								<p>{{ receiptDetail.reference }}</p>
							</div>
						</div>
						<div>
							<p
								style="font-weight: bold; padding-top: 15px; font-size: 15px; text-align: center;"
							>
								{{ receiptDetail.status.toUpperCase() }}
							</p>
						</div>
						<div
							class="item-row amount-row"
							:style="
								`padding: 0 15px;font-weight: bolder; color: #000;display: flex; justify-content:space-between;border-top: 1px solid black; border-bottom: 1px solid black;`
							"
						>
							<p>AMOUNT:</p>
							<p>N{{ receiptDetail.amount }}</p>
						</div>
					</div>
					<div class="receipt-footer">
						<p style="text-align: center; padding: 10px 3px;">
							Enjoy seamless transactions with PAYZEEP POS <br />
							PAYZEEP POS 1.0.5
						</p>
					</div>
				</div>
			</div>
			<div
			class="receipt-btns"
			style="display: flex; justify-content: center; gap: 30px; justify-content: center; margin-top: 10px;"
			>
			<button class="btn btn primary" @click="closeReceipt()">Close</button>
			<button class="btn btn-primary" @click="printReceipt()">Print</button>
		</div>
	</div>
	</div>
</template>

<script>
import logo from '@/assets/img/payzeep-logo.png';
import moment from 'moment';

export default {
	data() {
		return {
			logo: logo,
      moment,
		};
	},
	props: {
		showReceipt: {
			type: Boolean,
			required: true,
		},
		receiptDetail: {
			type: Object,
			required: true,
		},
		closeReceipt: {
			type: Function,
			required: true,
		},
	},
	methods: {
		printReceipt() {
			const receiptContent = this.$refs.printableContent;
			const a = window.open('', '', 'height=500, width=500');
			a.document.write('<html>');
			a.document.write('<body >');
			a.document.write(receiptContent.innerHTML);
			a.document.write('</body></html>');
			a.document.close();
			a.print();
			a.addEventListener('afterprint', () => {
				a.close();
			});
		},
	},
};
</script>

<style>
.vastrans-receipt {
	position: absolute;
	inset: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 999;
}
.vasreceipt-content-container {
	padding: 50px;
	background-color: rgba(0, 0, 0, 0.5);
	width: 100%;
}
</style>
